export default {
  "content": "<path d=\"M9 4a2 2 0 110 4 2 2 0 010-4zM9 10a2 2 0 110 4 2 2 0 010-4zM9 16a2 2 0 110 4 2 2 0 010-4zM15 4a2 2 0 110 4 2 2 0 010-4zM15 10a2 2 0 110 4 2 2 0 010-4zM15 16a2 2 0 110 4 2 2 0 010-4z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};